import { Component, computed, HostListener, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { FormComponent } from '@classes/form';
import { Article } from '@models/article-detail';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap/pagination';
import { AssetFormatterPipe } from '@pipes/asset-formatter-pipe';

@Component({
  imports: [RouterLink, NgbPagination, AssetFormatterPipe],
  selector: 'app-search',
  styleUrl: './search.scss',
  templateUrl: './search.html',
})
export class Search extends FormComponent {
  query = signal('');
  searchKey = signal('');
  searchTerm = signal('');
  isMobile = signal(false);
  page: number = 1;

  override data = signal<Article[]>([]);

  @HostListener('window:resize')
  onResize() {
    this.handleMobile();
  }

  private handleMobile() {
    this.isMobile.set(window.innerWidth < 768);
  }

  ngOnInit(): void {
    this.endpoint = 'api/search';
    this.method = 'get';

    this.route.queryParamMap.subscribe((params) => {
      this.searchKey.set(this.getSearchKey(params));

      this.query.set(params.get(this.searchKey()) ?? '');

      if (params.get('s')) {
        this.searchTerm.set(params.get('s') ?? '');
      }

      if (this.query() !== undefined && this.query() !== null) {
        this.page = 1;

        this.submit();
      } else {
        this.stopLoading();
      }
    });

    this.handleMobile();
  }

  getSearchKey(params: any) {
    let key = 's';

    if (params.get('a')) {
      key = 'a';
    } else if (params.get('t')) {
      key = 't';
    } else if (params.get('s')) {
      key = 's';
    }

    return key;
  }

  override submit(): void {
    this.data.set([]);

    super.submit();
  }

  override getParams() {
    return {
      page: this.page,
      [this.searchKey()]: this.query(),
      take: this.params.take,
    };
  }

  override success(response: any): void {
    this.data.set(response.data.rows ?? []);

    this.params.size = response.data.size;
    this.params.take = response.data.take;

    this.stopLoading();
  }

  override stopLoading(): void {
    this.loading.set(false);
    this.initialized.set(true);
  }
}
